/* eslint-disable react/button-has-type */
/* eslint-disable @typescript-eslint/no-use-before-define */
import ScientificResearchForm from '@/components/dashboard/members/profile/scientificResearches/ScientificResearchForm'
import { ScientificResearch } from '@/types/graphql/types'
import { useForm } from '@mantine/form'
import { useModals } from '@mantine/modals'
import useTranslation from 'next-translate/useTranslation'

const useScientificResearches = ({
  scientificResearch,
  refetch,
}: {
  scientificResearch: ScientificResearch[]
  // eslint-disable-next-line react/require-default-props
  refetch?: () => void
}) => {
  const modals = useModals()
  const { t } = useTranslation('common')

  const form = useForm({
    initialValues: {
      scientificResearch,
    },
  })

  const empty = form.values.scientificResearch.length === 0
  //update form data
  const handleUpdate = ({ newSR }: { newSR: ScientificResearch[] }) => {
    form.setFieldValue('scientificResearch', newSR)
    if (refetch) refetch()
  }
  //open scientific research update form
  const openScientificResearchForm = () =>
    modals.openModal({
      title: t('education'),
      children: (
        <ScientificResearchForm item={null} handleUpdate={handleUpdate} />
      ),
    })

  return {
    form,
    empty,
    openScientificResearchForm,
    handleUpdate,
  }
}

export default useScientificResearches
